import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2, Milestone } from "lucide-react";
import { api, track } from "@/lib/api";
import { PLANS } from "@/constants/testIds";

export default function Plans() {
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    track("plans_viewed");
    api.get("/plans").then(({ data }) => setPlans(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#C89B55] font-semibold">Growth Plans</p>
        <h1 className="font-heading text-3xl lg:text-4xl font-semibold mt-1">Guided paths for your season</h1>
        <p className="text-[#59535B] mt-2 max-w-xl">Short, structured journeys that bundle the right lessons in the right order — a day at a time.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {plans.map((p, i) => {
          const pct = p.total ? Math.round((p.done / p.total) * 100) : 0;
          return (
            <motion.button key={p.id} data-testid={`${PLANS.planCard}-${p.id}`} onClick={() => navigate(`/plans/${p.id}`)}
              initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: i * 0.05 }}
              className="text-left bg-white border border-[#291B2D]/5 rounded-3xl overflow-hidden card-soft hover:-translate-y-0.5 transition-smooth">
              <div className="h-2" style={{ backgroundColor: p.accent }} />
              <div className="p-6">
                <div className="flex items-center justify-between">
                  <span className="text-[10px] uppercase tracking-[0.2em] font-semibold" style={{ color: p.accent }}>{p.season}</span>
                  {p.enrolled && <span className="text-[10px] uppercase tracking-wide bg-[#ECF3EE] text-[#3D6B52] px-2 py-0.5 rounded-full font-semibold">Enrolled</span>}
                </div>
                <h3 className="font-heading text-xl font-semibold mt-2">{p.title}</h3>
                <p className="text-[#59535B] text-sm mt-1.5 leading-relaxed">{p.subtitle}</p>
                <div className="mt-4 flex items-center gap-3">
                  <div className="flex-1 h-1.5 bg-[#E5DED4] rounded-full overflow-hidden">
                    <div className="h-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: p.accent }} />
                  </div>
                  <span className="text-xs text-[#8A838E]">{p.done}/{p.total} days</span>
                </div>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
